import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { API_URL } from "../API/config";

const Offers = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [bannerData, setBannerData] = useState<any[]>([]);

  const success = (content: any) => {
    messageApi.open({
      type: "success",
      content: content,
      className: "custom-class",
    });
  };

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const copyToClipboard = (data: any) => {
    navigator.clipboard
      .writeText(data)
      .then(() => {
        success("Copied!");
      })
      .catch((error) => {
        console.error("Failed to copy coupon code: ", error);
        errormessage("Failed to copy coupon code!");
      });
  };

  const getOffBanner = async () => {
    const token = sessionStorage.getItem("token");
  
    try {
      const res = await axios.get(`${API_URL}/api/banner/offerBanners`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const trueData = res.data.banners.filter(
        (val: any) => val.actionButton === true
      );
      setBannerData(trueData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOffBanner();
  }, []);

  return (
    <>
      {contextHolder}
      <section className="pb-4" style={{ paddingTop: "6rem" }}>
        <Container>
          <div>
            <p className="title-para">Home - Offers</p>
            <h2 className="title-navhead">Offers</h2>
          </div>
        </Container>
        <div className="py-4">
          {bannerData.length > 0 && bannerData[0].link ? (
            <a href={bannerData[0].link}>
              <img
                src={`${API_URL}/images/${bannerData[0].image}`}
                className="img-fluid"
                alt="Offer Banner"
                loading="lazy"
              />
            </a>
          ) : bannerData.length > 0 ? (
            <img
              src={`${API_URL}/images/${bannerData[0].image}`}
              className="img-fluid"
              alt="Offer Banner"
              loading="lazy"
              style={{ cursor: "pointer" }}
              onClick={() => copyToClipboard(bannerData[0].couponCode)}
            />
          ) : (
            <p className="text-center">No offers available at the moment.</p>
          )}
        </div>
        <div className="py-4">
          <Container>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="p-2">
                  {bannerData.length > 1 && bannerData[1].link ? (
                    <a href={bannerData[1].link}>
                      <img
                        src={`${API_URL}/images/${bannerData[1].image}`}
                        className="img-fluid"
                        alt="Offer Banner"
                        loading="lazy"
                        style={{ cursor: "pointer" }}
                      />
                    </a>
                  ) : bannerData.length > 1 ? (
                    <img
                      src={`${API_URL}/images/${bannerData[1].image}`}
                      className="img-fluid"
                      alt="Offer Banner"
                      style={{ cursor: "pointer" }}
                      loading="lazy"
                      onClick={() => copyToClipboard(bannerData[1].couponCode)}
                    />
                  ) : (
                    <p className="text-center">
                      No offers available at the moment.
                    </p>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="p-2">
                  {bannerData.length > 2 && bannerData[2].link ? (
                    <a href={bannerData[2].link}>
                      <img
                        src={`${API_URL}/images/${bannerData[2].image}`}
                        className="img-fluid"
                        alt="Offer Banner"
                        loading="lazy"
                      />
                    </a>
                  ) : bannerData.length > 2 ? (
                    <img
                      src={`${API_URL}/images/${bannerData[2].image}`}
                      className="img-fluid"
                      alt="Offer Banner"
                      style={{ cursor: "pointer" }}
                      loading="lazy"
                      onClick={() => copyToClipboard(bannerData[2].couponCode)}
                    />
                  ) : (
                    <p className="text-center">
                      No offers available at the moment.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </div>
        <div className="py-4">
          {bannerData.length > 3 && bannerData[3].link ? (
            <a href={bannerData[3].link}>
              <img
                src={`${API_URL}/images/${bannerData[3].image}`}
                className="img-fluid"
                alt="Offer Banner"
                loading="lazy"
              />
            </a>
          ) : bannerData.length > 3 ? (
            <img
              src={`${API_URL}/images/${bannerData[3].image}`}
              className="img-fluid"
              alt="Offer Banner"
              loading="lazy"
              style={{ cursor: "pointer" }}
              onClick={() => copyToClipboard(bannerData[3].couponCode)}
            />
          ) : (
            <p className="text-center">No offers available at the moment.</p>
          )}
        </div>
      </section>
    </>
  );
};

export default Offers;
